// extracted by mini-css-extract-plugin
module.exports = {"boundary":"GlobalBoundary_boundary__snuZz","content":"GlobalBoundary_content__2F9Ha","details":"GlobalBoundary_details__1OXT1","errorInfo":"GlobalBoundary_errorInfo__1R6be"};